import { ClientResourcesColumnData } from './types';

export const columns: ClientResourcesColumnData[] = [
  { width: 150, label: 'Name', itemKey: 'name' },
  { width: 150, label: 'Position', itemKey: 'position' },
  // { width: 150, label: 'Seniority', itemKey: 'seniority' },
  { width: 150, label: 'Available from', itemKey: 'availableFromDate' },
  { width: 120, label: 'Availability', itemKey: 'allocation' },
];
